// extracted by mini-css-extract-plugin
module.exports = {"reg-for-free-mobile-button":"RegisterMobileButton_reg-for-free-mobile-button__9rxHl","Button":"RegisterMobileButton_Button__0HtjC"};